<script setup lang="ts">
import type { FormKitFrameworkContext } from '@formkit/core'
import RadioButtons from '../RadioButtons.vue'

const props = defineProps<{
  context: FormKitFrameworkContext
}>()

async function onUpdated(value: string) {
  await props.context.node.input(value)
}
</script>

<template>
  <RadioButtons
    :id="context.id"
    :model-value="props.context._value"
    :options="context.attrs['option-items']"
    @update:model-value="onUpdated"
  />
</template>
